( function( $ ) {
    /*anim init*/
    AOS.init();
    /*anim init*/

    /*header*/
    var hOffsetTop = 0;
    $(window).load(function(){
        if ($('.js-headerOffset').length > 0) {
            hOffsetTop = $('.js-header').offset().top;
        }
    });
    $(window).resize(function(){
        hOffsetTop = $('.js-header').offset().top;
    });
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight + hOffsetTop) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });

    $('.js-hMenuBtn').click(function() {
        $('.js-hMenu').addClass('active');
    });
    $('.js-hMenuCls').click(function() {
        $('.js-hMenu').removeClass('active');
    });

    $('.js-hMenu .menu a').click(function() {
        $('.js-hMenu').removeClass('active');
    });

    $('.js-hRdv').click(function() {
        $('.js-hRdvList').toggleClass('active');
    });

    /*header*/

    /*modal*/
    $('.js-modalOpen').click(function(e) {
        e.preventDefault();
        $('.js-modal').addClass('active');
    });
    $('.js-modalCls').click(function(e) {
        e.preventDefault();
        $('.js-modal').removeClass('active');
    });
    /*modal*/

    $(document).ready(function () {
        var iframe = $('#vimeo-player')[0];
        var player = new Vimeo.Player(iframe);
        player.getVolume().then(function (volume) {
            player.setVolume(0);
        });

        function toggleSound(_this) {
            player.getVolume().then(function (volume) {
                _this.find('.sound').removeClass('active');
                if (volume > 0) {
                    player.setVolume(0);
                    _this.find('.sound[data-sound="disabled"]').addClass('active');
                } else {
                    player.setVolume(1);
                    _this.find('.sound[data-sound="enabled"]').addClass('active');
                }
            });
        }

        $('.js-firstLoud').on('click', function () {
            toggleSound($(this));
        });
    });

    /*second dropdown*/
    $('.js-secondRdv').click(function(){
        $(this).toggleClass('active')
    })
    $('body').on('mousedown', function(e){
        if (!e.target.classList.contains('js-secondRdv') && !e.target.closest('.js-secondRdv')) {
            $('.js-secondRdv').removeClass('active');
        }
    });
    /*second dropdown*/


    /*traits*/
    $(document).ready(function(){
        var windowHeight = $(window).height();
        const pCabSMController = new ScrollMagic.Controller,
            pCabValListItemClass = ".js-traitScrollItem";

        const trigHook = 1;
        var custIndex = 1;
        $(pCabValListItemClass).each((function(t) {
            var anim = (new TimelineMax).from($(this), .01, {
                scale: 1.4,
                ease: Linear.easeNone
            }).to($(this), .01, {
                scale: 1,
                ease: Linear.easeNone
            });
            new ScrollMagic.Scene({
                triggerElement: '.js-traitScrollItem[data-scroll="'+custIndex+'"]',
                duration: windowHeight
            }).setTween(anim).triggerHook(trigHook).addTo(pCabSMController);
            custIndex++;
        }));
    });
    /*traits*/


    /*BlogTabs*/
    $('.js-mainBlogTabs').click(function(e){
        e.preventDefault();
        var href = $(this).attr('href');
        $('.js-mainBlogTabs').removeClass('active');
        $(this).addClass('active');
        $('.js-mainBlogCont').removeClass('active');
        $('.js-mainBlogCont'+href).addClass('active');
    });
    /*BlogTabs*/


    /*cabinet image worker*/
    $('.js-cabinValsImgChange').on('mouseover', function(){
        $('.js-cabinValsImg img').attr('src', $(this).data('img'));
    });
    /*cabinet image worker*/

    /*float placeholders*/
    $('body').click(function(){
        $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').each(function(el){
            if ($(this).val() === '')
                $(this).closest('.wpcf7-form-control-wrap').removeClass('active');

        });
    })
    $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').click(function(){
        var _this = $(this);
        setTimeout(function(){
            $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').each(function(el){
                if ($(this).val() === '')
                    $(this).closest('.wpcf7-form-control-wrap').removeClass('active');

            });
            _this.closest('.wpcf7-form-control-wrap').addClass('active');
        }, 5)
    })
    /*float placeholders*/

    /*tech*/
    // $('.js-techBlTxt').each(function(){
    //     if ($(this).height() < $(this).find('.js-techBlTxtIn').height()) {
    //         $(this).siblings('.js-techBlBtn').css('display', 'block')
    //         $(this).find('.js-techBlMore').css('display', 'block')
    //     }
    // });
    // $('.js-techBlBtn').click(function(e){
    //     e.preventDefault();
    //     if ($(this).hasClass('active')) {
    //         $(this).removeClass('active');
    //         $(this).siblings('.js-techBlTxt').removeClass('active');
    //         $(this).siblings('.js-techBlTxt').find('.js-techBlMore').css('display', 'block');
    //     } else {
    //         $(this).addClass('active');
    //         $(this).siblings('.js-techBlTxt').addClass('active');
    //         $(this).siblings('.js-techBlTxt').find('.js-techBlMore').css('display', 'none');
    //     }
    // })

    // $('.js-techBlTxt').each(function(){
    //     var $jsText = $(this);
    //     var originalText = $jsText.find('.js-techBlTxtIn').text();
    //     var originalHtml = $jsText.find('.js-techBlTxtIn').html();
    //     console.log(originalText.length);
    //     if (originalText.length > 435) {
    //         $(this).siblings('.js-techBlBtn').css('display', 'block')
    //         var shortenedText = originalText.substring(0, 400) + '[...]';
    //         $jsText.find('.js-techBlTxtIn').text(shortenedText);
    //     }
    //
    //     $(this).siblings('.js-techBlBtn').on('click', function (e) {
    //         e.preventDefault();
    //         $jsText.find('.js-techBlTxtIn').html(originalHtml);
    //         $(this).remove();
    //     });
    // });
    $('.js-techBlBtn a').click(function(e){
        var par = $(this).closest('.js-techBlBtn')
        e.preventDefault();
        if (par.siblings('.js-techBlTxt').hasClass('full')) {
            $(this).text($(this).data('plus'));
            par.siblings('.js-techBlTxt').removeClass('full');
            par.siblings('.js-techBlTxt').find('.js-techBlTxtPart').removeClass('d-none');
            par.siblings('.js-techBlTxt').find('.js-techBlTxtFull').addClass('d-none');
        } else {
            $(this).text($(this).data('minus'));
            par.siblings('.js-techBlTxt').addClass('full');
            par.siblings('.js-techBlTxt').find('.js-techBlTxtPart').addClass('d-none');
            par.siblings('.js-techBlTxt').find('.js-techBlTxtFull').removeClass('d-none');
        }
    });

    // Обработчик события для кнопки
    /*tech*/


    /*cliniques filter*/
    $('.js-catClinTerms').click(function(e){
        e.preventDefault();
        $('.js-catClinTerms').removeClass('active');
        $(this).addClass('active');
        if ($(this).data('categ') === 'all') {
            $('.js-catClinPosts').addClass('active')
        } else {
            $('.js-catClinPosts').removeClass('active')
            $('.js-catClinPosts[data-categ="' + $(this).data('categ') + '"]').addClass('active')
        }
    })
    /*cliniques filter*/

    /*cliniques sliders*/
    $( '.js-catClinSlider' ).each(function(){
        $(this).slick( {
            fade: false,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            draggable: false,
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            appendArrows: $(this).closest('.js-catClinSliderSlide').find('.js-catClinSliderArrows'),
            prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M22.5 12L2 12M2 12L8.5 18.5M2 12L8.5 5.5" stroke="#A8AAAE"/> </svg></button>"',
            nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M1.5 12L22 12M22 12L15.5 18.5M22 12L15.5 5.5" stroke="#A8AAAE"/> </svg></button>',

        } );
    })
    /*cliniques sliders*/

    /*google slider*/
    $( '.js-pageGoogleSlider' ).slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        appendArrows: $('.js-pageGoogleSliderArrows'),
        prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M22.5 12L2 12M2 12L8.5 18.5M2 12L8.5 5.5" stroke="#A8AAAE"/> </svg></button>"',
        nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M1.5 12L22 12M22 12L15.5 18.5M22 12L15.5 5.5" stroke="#A8AAAE"/> </svg></button>',
        responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            }
        }
    ]

    } );
    /*google slider*/

    /*page team slider*/
    $(document).ready(function(){

        $('.js-teamSlider').each(function() {
            var slides = $(this).data('slides');
            $(this).slick({
                dots: false,
                arrows: true,
                prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M22.5 12L2 12M2 12L8.5 18.5M2 12L8.5 5.5" stroke="#A8AAAE"/> </svg></button>"',
                nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M1.5 12L22 12M22 12L15.5 18.5M22 12L15.5 5.5" stroke="#A8AAAE"/> </svg></button>',
                infinite: true,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 700,
                slidesToShow: slides,
                slidesToScroll: slides,
                appendArrows: $(this).closest('.js-teamSliderWrap').find('.js-teamSliderArrows'),
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        });
    })
    /*page team slider*/

    /*page team slider*/
    $(document).ready(function(){

        $('.js-pageCabinGalSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
            $('.js-pageCabinGalSliderPagination').removeClass('d-none');
            var cnt = slick.options.slidesToScroll;
            var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
            $(".js-pageCabinGalSliderCounter").html(
                '<span>' + slideNum + '</span><span class="sep">—</span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
            );
            if (Math.ceil(slick.slideCount / slick.options.slidesToShow) <= 1) {
                $('.js-pageCabinGalSliderPagination').addClass('d-none');
            }
        });
        $('.js-pageCabinGalSlider').slick({
            dots: false,
            arrows: true,
            prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M22.5 12L2 12M2 12L8.5 18.5M2 12L8.5 5.5" stroke="#A8AAAE"/> </svg></button>"',
            nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M1.5 12L22 12M22 12L15.5 18.5M22 12L15.5 5.5" stroke="#A8AAAE"/> </svg></button>',
            infinite: true,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $('.js-pageCabinGalArrows'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    })
    /*page team slider*/

    /*form*/
    document.addEventListener('wpcf7invalid', function(event) {
        setTimeout(function(){
            var firstError = document.querySelector('.wpcf7-not-valid');
            var errorPosition = firstError.getBoundingClientRect().top + window.scrollY - 189;

            window.scrollTo({
                top: errorPosition,
                behavior: 'smooth'
            });
        }, 500);
    }, false);
    /*form*/

}( jQuery ) );
